module.exports = __webpack_public_path__ + "img/icon-exclamation-red.92a9c901.svg";